<template>
    <b-tab @click="loadStepData()" lazy v-if="isVisible">
        <template #title>
            <b-spinner v-if="showSpinner" type="border" small></b-spinner>
            {{ $t('prod_steps', { ns: 'production' }) }}
        </template>
        <b-card-text>
            <b-table
                striped
                responsive
                :fields="fieldsSteps"
                :items="stepsList"
                primary-key
            >
            </b-table>
        </b-card-text>
    </b-tab>
</template>
<script>
import { loadItem } from '../../models/DataHelper';
import DateHelper from '../../models/DateHelper';
export default {
    name: 'StepsLog',
    data() {
        return {
            showSpinner: false,
            isVisible: true,
            fieldsSteps: [
                {
                    key: 'tijd',
                    label: this.$t('prod_gemaakt', { ns: 'production' }),
                    formatter: this.displayDateTime
                },
                {
                    key: 'tijdsduurvolgende',
                    label: this.$t('com_timespan', { ns: 'common' })
                },
                {
                    key: 'programma',
                    label: this.$t('prod_xprogramma', {
                        val: '',
                        ns: 'production'
                    })
                },
                {
                    key: 'stapNummer',
                    label: '#'
                },
                {
                    key: 'stapOmschrijving',
                    label: this.$t('com_omschrijving', { ns: 'common' })
                },
                {
                    key: 'temperatuur',
                    label: this.$t('com_temperatuur', { ns: 'common' })
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_amount', { ns: 'common' })
                }
            ],
            stepsList: []
        };
    },
    props: {
        lijst: {
            type: Array
        },
        action: {
            type: String
        },
        id: {
            type: Number
        },
        paramName: {
            type: String
        }
    },
    watch: {},
    components: {},
    computed: {},
    methods: {
        displayDateTime(value) {
            return DateHelper.convertedToDateTimeShort(value, false);
        },
        async loadStepData() {
            this.showSpinner = true;
            if (this.lijst != undefined) {
                this.stepsList = this.lijst;
                this.showSpinner = false;
                return;
            }
            if (this.id != undefined) {
                this.showSpinner = true;
                this.stepsList = await loadItem(
                    this.action,
                    { [this.paramName]: this.id },
                    this.$t
                );
            }
            this.showSpinner = false;
        }
    },
    mounted() {},
    created() {}
};
</script>

<style scoped></style>
